import { render, staticRenderFns } from "./my-notifications.vue?vue&type=template&id=0689a600&"
import script from "./my-notifications.vue?vue&type=script&lang=js&"
export * from "./my-notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports